<template>
    <div class="pcr-user-informations">
        <div v-if="user">
            <div class="tab-contextual-button">                
                <el-dropdown trigger="click">
                    <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator && !user.RegistrationDate">
                            <div @click="invite">Envoyer une invitation</div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator && user.RegistrationDate">
                            <div @click="showChangePasswordModal = true">Changer le mot de passe</div>
                        </el-dropdown-item>
                        <el-dropdown-item v-show="!editing" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                            <div @click="startEdit">Editer l'utilisateur</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            
            <change-password-user-modal :visible.sync="showChangePasswordModal" :user-id="userId"></change-password-user-modal>
    
            <ck-form ref='ck-form' label-position="top" :read-only="!editing">
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-informations label="Identifiant" :display="user.UserId"></ck-informations>
                    </el-col>
                </el-row>
                
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-informations label="Dernière invitation" :display="$humanize(user.LastInvitationDate)"></ck-informations>
                    </el-col>
                    <el-col :span="12">
                        <ck-informations label="Date d'inscription" :display="$humanize(user.RegistrationDate)"></ck-informations>
                    </el-col>
                </el-row>
                <el-row :gutter="12">
                    <el-col :span="4">
                        <ck-form-item label="Civilité" :display="user.CivilityString">
                            <el-select v-model="user.Civility" placeholder="Select">
                                <el-option
                                v-for="item in civilities"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: user.Civility, trigger: 'change' }">
                                Veuillez indiquer la civilité
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
    
                    <el-col :span="10">
                        <ck-form-item label="Nom" :display="user.LastName">
                            <el-input v-model="user.LastName" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: user.LastName, trigger: 'change' }">
                                Veuillez indiquer le nom
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="10">
                        <ck-form-item label="Prénom" :display="user.FirstName">
                            <el-input v-model="user.FirstName" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: user.FirstName, trigger: 'change' }">
                                Veuillez indiquer le prénom
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <!-- <el-col :span="24">
                        <ck-form-item label="Email" :display="user.PrimaryEMail">
                            <el-input v-model="user.PrimaryEMail" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: user.PrimaryEMail, trigger: 'change' }">
                                Veuillez indiquer l'e-mail
                            </ck-validator>
                        </ck-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <ck-informations label="Email" :display="user.PrimaryEMail"></ck-informations>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Numéro de téléphone" :display="user.PhoneNumber">
                            <el-input v-model="user.PhoneNumber" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <div v-show="editing">
                    <div class="pull-right">
                        <el-button type="default" @click="cancelEdit" native-type="submit">Annuler</el-button>
                        <el-button type="primary" @click="endEdit" native-type="submit">Enregistrer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('user-informations', {
    props: {
        userId: {
            default: () => 0
        }
    },
    data() {
        return {
            refreshing: false,
            user: null,
            tmpUser: null,
            editing: false,
            civilities: [{ value: 0, label: 'Mr' }, { value: 1, label: 'Mme' }, { value: 2, label: 'Dr' }],
            showChangePasswordModal: false
        }
    },
    computed: {
        canEdit() {
            console.log(this.$currentTreeNode.Rights)
            return this.$currentTreeNode.Rights.GrantLevel >= this.$grantLevel.administrator && ( this.$user.IsSysAdmin || (this.$user.IsPartnerAdmin && !this.user.IsPartnerAdmin ) );
        }
    },
    mounted: function () {
        this.refresh();
        
        this.$root.$on('pcr_update_data', () => {
            this.refresh();
        });
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/user/' + this.userId).then((response) => {
                    this.user = response.data;
                    this.refreshing = false;
                });
            }
        },
        startEdit(e) {
            e.preventDefault();

            this.tmpUser = _.cloneDeep(this.user);

            this.editing = true;
        },
        cancelEdit(e) {
            e.preventDefault();

            this.user = this.tmpUser;
            this.tmpUser = null;

            this.editing = false;
        },
        endEdit(e) {
            e.preventDefault();
            this.$refs['ck-form'].validate((valid) => {
                if (valid) {
                    this.$http.post('/api/user/' + this.userId, this.user).then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Sauvegarder',
                            text: 'Vos modifications ont bien été sauvegardées'
                        }).then(() => {

                        });

                        this.tmpUser = null;
                        this.editing = false;

                        this.$root.$emit('pcr_update_data');
                        this.$root.$emit('pcr_update_tree');
                    });
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        },
        invite() {
            var establishmentId = this.$router.currentRoute.query.establishmentId;
            this.$swal({
                type: 'warning',
                title: 'Invitation',
                text: 'Etes-vous sûr de vouloir renvoyer une invitation à cet utilisateur ?',
                showCancelButton: true,
                confirmButtonText: 'Confirmer',
                cancelButtonText: 'Annuler'
            }).then(() => {
                this.$http.post(`/api/user/${this.userId}/invite/${establishmentId ? establishmentId : 1}`)
                    .then((response) => {
                        this.$defaultSwalApiResponse(response, () => {
                            this.$swal({
                                type: 'success',
                                title: 'Invité',
                                text: 'L\'invitation a bien été envoyée'
                            });
                            
                            this.$root.$emit('pcr_update_data');
                        }, this.$defaultSwalApiResponse);
                    });
            });
        },
    },
    watch: {
        userId(val) {
            if (val) {
                this.refresh();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/user/user-informations.vue